import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import ServerDetail from './components/ServerDetail';
import ReferenceServers from './components/ReferenceServers';
import ThirdPartyServers from './components/ThirdPartyServers';
import CommunityServers from './components/CommunityServers';
import BackgroundCanvas from './components/BackgroundCanvas';

function App() {
    const location = useLocation();
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Simulating loading for a smooth entry animation
        setTimeout(() => {
            setIsLoaded(true);
        }, 500);
    }, []);

    return (
        <div className="App min-h-screen flex flex-col">
            <BackgroundCanvas />

            <div className={`transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
                <Header />

                <main className="flex-grow container mx-auto px-4 py-8">
                    <AnimatePresence mode="wait">
                        <Routes location={location} key={location.pathname}>
                            <Route path="/" element={<Home />} />
                            <Route path="/servers/:serverName" element={<ServerDetail />} />
                            <Route path="/reference-servers" element={<ReferenceServers />} />
                            <Route path="/thirdparty-servers" element={<ThirdPartyServers />} />
                            <Route path="/community-servers" element={<CommunityServers />} />
                        </Routes>
                    </AnimatePresence>
                </main>

                <Footer />
            </div>
        </div>
    );
}

export default App;